var React = require('react');

function ReturnArrowReverse (props) {
    return React.createElement("svg",props,[React.createElement("style",{"key":0},".st2{fill:#ff9c00}"),React.createElement("circle",{"cx":"32","cy":"32","r":"31.2","fill":"#fff","key":1}),React.createElement("path",{"d":"M32 64C14.4 64 0 49.6 0 32S14.4 0 32 0s32 14.4 32 32-14.4 32-32 32zm0-62.4C15.2 1.6 1.6 15.2 1.6 32S15.2 62.4 32 62.4 62.4 48.8 62.4 32 48.8 1.6 32 1.6z","fill":"#e6e6e6","key":2}),React.createElement("path",{"transform":"rotate(-45.001 42.527 36.042)","className":"st2","d":"M34.9 34.1h15.3v3.8H34.9z","key":3}),React.createElement("path",{"transform":"rotate(-45.001 42.527 27.958)","className":"st2","d":"M40.6 20.3h3.8v15.3h-3.8z","key":4}),React.createElement("path",{"className":"st2","d":"M14.9 30.1h31.7v3.8H14.9z","key":5})]);
}

ReturnArrowReverse.defaultProps = {"id":"Layer_1","viewBox":"0 0 64 64"};

module.exports = ReturnArrowReverse;

ReturnArrowReverse.default = ReturnArrowReverse;
